import React from 'react';
import cs from 'classnames';

import LabeledInput from '~/components/common/LabeledInput';

import css from './weightinput.css';

const weightInput = (props) => (
  <div className={cs({[css.wrap]:(props.input && !props.input.wrapClassName)}, 'qa-weight-input')}>
    <LabeledInput
      {...props.input}
      type = 'number'
      mediumInput
      label={ props.label || 'Weight (lbs)'}
      value={props.value || ''}
      onChange={props.onChange}
    />
  </div>
);

export default weightInput;



// WEBPACK FOOTER //
// ./src/components/common/weightInput/index.js